import {
  Edition,
  Duration,
  LMUTV_PRICING,
} from "../../Settings";

export type CartLine = {
  edition: Edition;
  duration: Duration;
  pcs: number;
  // ISO date string (YYYY-MM-DD). Only meaningful for 3m / 1y; ignored for lifetime.
  startsAt?: string;
};

export const FULL_PRICE_PCS = 3;
export const BULK_DISCOUNT = 0.5;

export function unitPrice(edition: Edition, duration: Duration): number {
  return LMUTV_PRICING[edition][duration];
}

export function getLineTotal(line: CartLine): number {
  const u = unitPrice(line.edition, line.duration);
  if (line.pcs <= FULL_PRICE_PCS) return u * line.pcs;
  return u * FULL_PRICE_PCS + u * BULK_DISCOUNT * (line.pcs - FULL_PRICE_PCS);
}

export class Cart {
  Items: CartLine[] = [];

  Quantity(): number {
    return this.Items.reduce((s, l) => s + l.pcs, 0);
  }

  Total(): number {
    return this.Items.reduce((s, l) => s + getLineTotal(l), 0);
  }

  AddLineItem(edition: Edition, duration: Duration, pcs: number, startsAt?: string): void {
    if (pcs <= 0) return;
    // Lines with the same (edition, duration, startsAt) merge their pcs.
    // Different start dates should stay as distinct lines so the keys can
    // be issued with the right validUntil window each.
    const idx = this.Items.findIndex(
      (l) => l.edition === edition && l.duration === duration && (l.startsAt ?? "") === (startsAt ?? "")
    );
    if (idx >= 0) this.Items[idx].pcs += pcs;
    else this.Items.push({ edition, duration, pcs, startsAt });
  }

  SetLine(index: number, pcs: number): void {
    if (pcs <= 0) {
      this.Items.splice(index, 1);
      return;
    }
    this.Items[index].pcs = pcs;
  }

  RemoveLine(index: number): void {
    this.Items.splice(index, 1);
  }

  Clear(): void {
    this.Items = [];
  }
}
